import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  eventImages: {
    display: 'flex',
    position: 'relative',
    padding: '0!important',
  },

  imgSquare: {
    width: '288px',
    height: '288px',

    '&.photo': {
      cursor: 'pointer',
    },

    '@media screen and (min-width: 1441px) ': {
      width: '384px',
      height: '384px',
    },
  },
}));

export default useStyles;
